import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=0fd288a0&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=0fd288a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd288a0",
  null
  
)

export default component.exports